export default function HowItWorks() {
  const steps = [
    { n: "01", h: "Sign up free", b: "Register at any Stellar forecourt with your UAE mobile number — or online at stellar.ae. Receive an instant 100-point welcome bonus, enough for your first coffee." },
    { n: "02", h: "Fill up. Grab a coffee.", b: "Every fill-up, cappuccino, snack, car wash, and grocery run at a Stellar forecourt earns 1 point per AED 1 spent (higher at Silver / Gold / Platinum)." },
    { n: "03", h: "Quote your mobile — or scan at the pump", b: "Share your registered UAE mobile at the till, or scan the QR at the pump. Points post to your Stellar wallet in seconds and a VAT invoice lands on WhatsApp." },
    { n: "04", h: "Confirm redemptions with an OTP", b: "For your security, a one-time passcode is sent to your registered mobile before any points are redeemed against your account." },
    { n: "05", h: "Redeem how you like", b: "1 point = AED 0.25. Use 100 points or more to discount fuel, a coffee, a car wash, or convenience-store items at any of the 48+ Stellar forecourts across the UAE." },
  ];
  return (
    <div className="max-w-[1300px] mx-auto px-6 lg:px-12 py-20" data-testid="page-how">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">HOW IT WORKS</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-16">Simple, by<br /><em className="font-light">design.</em></h1>
      <div className="space-y-12">
        {steps.map((s) => (
          <div key={s.n} className="grid lg:grid-cols-[140px_1fr] gap-6 border-b border-black/10 pb-12 last:border-0">
            <div className="font-display text-6xl kazo-text-champagne" style={{ fontWeight: 300 }}>{s.n}</div>
            <div>
              <h3 className="font-display text-3xl mb-3">{s.h}</h3>
              <p className="text-neutral-600 leading-relaxed text-lg max-w-2xl">{s.b}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
